import React from 'react';

import { cssMap } from '@atlaskit/css';
import Heading from '@atlaskit/heading/heading';
import { Box, Stack, Text } from '@atlaskit/primitives/compiled';

const styles = cssMap({
	textContainer: {
		flex: '1 1 0%',
		minWidth: '0px',
		maxWidth: '100%',
	},
	truncate: {
		minWidth: '0px',
		maxWidth: '100%',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
	},
});

export interface UserContentProps {
	name: string;
	jobTitle?: string | null;
}

/**
 * Internal component that renders the user name and optional job title.
 */
function UserContent({ name, jobTitle }: UserContentProps): React.JSX.Element {
	return (
		<Stack space="space.0" xcss={styles.textContainer}>
			<Box xcss={styles.truncate}>
				{/* `as="span"` keeps heading typography while the name stays inline so this Box’s overflow can be controlled */}
				<Heading as="span" size="xsmall">
					{name}
				</Heading>
			</Box>
			{jobTitle && (
				<Text size="small" color="color.text.subtlest" maxLines={1}>
					{jobTitle}
				</Text>
			)}
		</Stack>
	);
}

export { UserContent };
